/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Projects_Col_StatusInputs */

const cs_projects_col_status = /** @type {(inputs: Projects_Col_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sreality`)
};

const en_projects_col_status = /** @type {(inputs: Projects_Col_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sreality`)
};

/**
* | output |
* | --- |
* | "Sreality" |
*
* @param {Projects_Col_StatusInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const projects_col_status = /** @type {((inputs?: Projects_Col_StatusInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Projects_Col_StatusInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_projects_col_status(inputs)
	return cs_projects_col_status(inputs)
});